import {
    CheckRegistrationProgress,
    OrganizationRegistration,
    OrgRegistrationResponse,
    RegistrationProgress,
    VerifyEmailResponse
} from '@model/employer';
import { fetchBody, makeGet, makeRequest } from './util';

// Check if email exists
export function checkEmail(email: string): Promise<boolean> {

    const url = `/__/a/22/1/1/17/usr/UserRoleCheck?$filter=UserType eq 'employer' and email eq '${email}'`;

    const request = makeGet(url);

    return fetchBody(request)
        .then((x) => x.length > 0);
}

// check if tenant name exists
export function checkTenant(name: string): Promise<boolean> {

    const url = `/__/a/22/1/1/17/ptf/CheckTenant?$filter=Name eq '${name}'`;

    const request = makeGet(url);

    return fetchBody(request)
        .then((x) => x.length > 0);
}

// check if sub domain exists
export function checkSubDomain(name: string): Promise<boolean> {
    const url = `/__/a/22/1/1/1/ptf/SubDomainCheck?$filter=Name eq '${name}'`;

    const request = makeGet(url);

    return fetchBody(request)
        .then((x) => x[0].isAvailable);
}

export function provisionTenant(payload: OrganizationRegistration): Promise<OrgRegistrationResponse> {
    const url = `/__/a/22/1/1/21/ptf/ProvisionTenant`;

    return fetchBody<any>(makeRequest('POST', url, payload))
        .then(parseOrgRegistrationResponse);
}

export function verifyProvisionTenant(requestId: string, requestType: 'Verify' | 'Resend', code: string = ''):
    Promise<VerifyEmailResponse> {

    const url = `/__/a/22/1/1/21/ptf/VerifyProvisionTenant`;

    const payload = {
        requestId,
        requestType,
        code
    };

    return fetchBody<any>(makeRequest('PUT', url, payload))
        .then(parseVerifyEmail);
}

function parseVerifyEmail(data: any): VerifyEmailResponse {
    return {
        requestId: data.requestId,
        requestType: data.requestType,
        code: data.code
    };
}

export function checkRegistrationProgress(requestId: string): Promise<CheckRegistrationProgress> {
    const url = `/__/a/22/1/1/21/ptf/ProvisionTenant?include=progress&$filter=RequestId eq (${requestId})`;

    const request = makeGet(url);

    return fetchBody(request)
        .then((x) => parseRegistrationProgress(x[0]));
}

export function directLogin(username: string, password: string): Promise<boolean> {
    const url = '/internal/auth/login';

    const body = {
        username,
        password
    };

    return fetchBody<any>(makeRequest('POST', url, body))
        .then((_) => true)
        .catch((_) => false);
}

export function uploadOrgLogo(requestId: string, logoUrl: string): Promise<boolean> {
    const url = '/__/a/22/1/1/21/ptf/TenantLogo';

    const body = {
        RequestId: requestId,
        LogoUrl: logoUrl
    };

    return fetchBody<any>(makeRequest('POST', url, body))
        .then((_) => true);
}

function parseOrgRegistrationResponse(data: any): OrgRegistrationResponse {
    return {
        id: data.id,
        tenantId: data.aId,
        crOn: data.crOn,
        requestId: data.requestId,
        ...data
    };
}

function parseRegistrationProgress(data: any): CheckRegistrationProgress {
    return {
        id: data.id,
        tenantId: data.aId,
        crOn: data.crOn,
        requestId: data.requestId,
        progress: parseProgress(data.progress),
        ...data
    };
}

function parseProgress(data: any): RegistrationProgress[] {
    return data.map((progress) => {
        return {
            id: progress.id,
            description: progress.description,
            status: progress.status,
            ordinalPosition: progress.ordinalPosition
        };
    });
}
